import { Field, Float, Int, ObjectType } from '@nestjs/graphql'
import { UserDto } from '../../user/model.dto'
import { BaseModelDto } from '../../base/baseModel.dto'
import { ArcTeamDto } from '../model.dto'
import { UserEmailDto } from '../../user'

@ObjectType()
export class ArcTeamMemberDto extends BaseModelDto {
  @Field(t => Boolean, { defaultValue: false })
  isDraft: boolean = false

  @Field(t => Int)
  status!: number // Approved, blocked, rejected etc.

  @Field(t => Int)
  type!: number // normal / VIP etc

  @Field({ nullable: true })
  user?: UserDto

  @Field(t => Int, { nullable: true, defaultValue: 0 })
  activeArcCount?: number = 0

  @Field(t => Int, { nullable: true, defaultValue: 0 })
  reviewedArcCount?: number = 0

  @Field(t => Int, { nullable: true, defaultValue: 0 })
  cancelledArcCount?: number = 0

  @Field(t => Int, { nullable: true, defaultValue: 0 })
  pastDueArcCount?: number = 0

  @Field(t => Float, { nullable: true, defaultValue: 0 })
  averageRating?: number = 0

  @Field(t => ArcTeamDto, { nullable: true })
  arcTeam?: ArcTeamDto

  @Field(t => Int)
  arcTeamId!: number

  @Field({ nullable: true })
  statusReasonType?: number

  @Field({ nullable: true })
  statusReason?: string

  @Field({ nullable: true })
  reportedDate?: Date

  @Field({ nullable: true })
  statusDate?: Date

  @Field(t => UserEmailDto, { nullable: true })
  userEmail?: UserEmailDto

  @Field(t => Int, { nullable: true })
  previousStatus?: number

  @Field(t => Int, { nullable: true })
  previousType?: number

  @Field(t => Int, { nullable: true })
  reviewerStatus?: number

  @Field(t => Int, { nullable: true })
  reviewerLogType?: number
}
